import React from "react";
import styles from "./dropBtn.module.css";

const MoreDropBtn = (props) => {
  return (
    <>
      <div className={styles.container}>
        <ul className={styles.drop_container}>
          {props.drop_list.map((val, index) => {
            return (
              <li
                key={index}
                className={styles.drop_item}
                id={val.id}
                onClick={(e) => {
                  props.on_click(e.target.id);
                }}
              >
                {val?.icon && (
                  <val.icon style={{ height: "18px", width: "18px" }} />
                )}
                {val.title}
              </li>
            );
          })}
        </ul>

        <div
          className={styles.cover}
          onClick={() => {
            props.setMoreDropdown((prev) => !prev);
          }}
        ></div>
      </div>
    </>
  );
};

export default MoreDropBtn;
